const VALID_DELIVERY_OPTIONS = new Set(['pickup', 'shipping']);

const normalizeDeliveryOption = option =>
  typeof option === 'string' ? option.trim().toLowerCase() : null;

export const resolveListingDeliveryOptions = publicData => {
  const rawDeliveryOption = publicData?.deliveryOption;

  if (Array.isArray(rawDeliveryOption)) {
    return rawDeliveryOption
      .map(normalizeDeliveryOption)
      .filter(option => option && VALID_DELIVERY_OPTIONS.has(option))
      .filter((option, index, arr) => arr.indexOf(option) === index);
  }

  if (typeof rawDeliveryOption === 'string') {
    const normalized = normalizeDeliveryOption(rawDeliveryOption);
    return normalized && VALID_DELIVERY_OPTIONS.has(normalized) ? [normalized] : [];
  }

  const fallbackOptions = [];
  if (publicData?.pickupEnabled) {
    fallbackOptions.push('pickup');
  }
  if (publicData?.shippingEnabled) {
    fallbackOptions.push('shipping');
  }
  return fallbackOptions;
};

export const listingMatchesDeliveryOptions = (publicData, selectedOptions = []) => {
  if (!Array.isArray(selectedOptions) || selectedOptions.length === 0) {
    return true;
  }

  const normalizedSelectedOptions = selectedOptions
    .map(normalizeDeliveryOption)
    .filter(option => option && VALID_DELIVERY_OPTIONS.has(option));

  if (!normalizedSelectedOptions.length) {
    return true;
  }

  const resolvedOptions = resolveListingDeliveryOptions(publicData);
  return resolvedOptions.some(option => normalizedSelectedOptions.includes(option));
};
